export function accordion(){
  const accordions = document.body.querySelectorAll('.js_accordion')

  accordions.forEach((elm)=>{
    const trigger = elm.querySelector('.js_accordion_trigger')
    trigger.addEventListener('click' ,()=>{
      elm.classList.toggle('is_opened')
    })
  })
}
